module.exports = __webpack_public_path__ + "assets/img/dzh-22.077d00a9.jpg";